export default {
  methods: {
    turnOffLoading() {
      this.loading = false;
    }
  }
};
